module.exports = __webpack_public_path__ + "img/Bell.51b2887.svg";